export type LocationSummaryColumnKey =
  | 'region'
  | 'market'
  | 'location'
  | 'created'
  | 'target'
  | 'ptExecution'
  | 'approved'
  | 'pending'
  | 'declined';

export interface LocationSummaryColumn {
  key: LocationSummaryColumnKey;
  label: string;
  minWidth: number;
  isNumeric?: boolean;
}

export const LOCATION_SUMMARY_COLUMNS: LocationSummaryColumn[] = [
  { key: 'region', label: 'Region', minWidth: 170 },
  { key: 'market', label: 'Market', minWidth: 170 },
  { key: 'location', label: 'Location', minWidth: 180 },
  { key: 'created', label: 'Created', minWidth: 110, isNumeric: true },
  { key: 'target', label: 'Target', minWidth: 110, isNumeric: true },
  { key: 'ptExecution', label: 'Perfect Truck Execution', minWidth: 170, isNumeric: true },
  { key: 'approved', label: 'Approved', minWidth: 110, isNumeric: true },
  { key: 'pending', label: 'Pending', minWidth: 110, isNumeric: true },
  { key: 'declined', label: 'Declined', minWidth: 110, isNumeric: true },
];

export type SortDirection = 'asc' | 'desc';
